import {
  configureStore,
  ThunkAction,
  Action,
  getDefaultMiddleware,
  combineReducers,
} from "@reduxjs/toolkit";
import noticeReducer from "./reducers/notices/noticeReducer";
import cookieReducer from "./reducers/notices/cookieReducer";
import userPopup from "./reducers/menu/userPopup";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";
import accountSlice from "./reducers/account/accountSlice";
import htmlContainerReducer from "./reducers/htmlContainer/htmlContainerReducer";
import themeReducer from "./reducers/theme/themeReducer";
import mapFilterSlice from "./reducers/map/mapFilter";
import ValidAuthSlice from "./reducers/auth/isAuth";
import { stompMiddleware } from "./stomp/stompMiddleware";
import { stompReducer } from "./stomp/stompSlice";
import { stompMapReducer } from "./stomp/stompMapSlice";
import { stompSubscriptionReducer } from "./stomp/stompSubscriptionSlice";
import awsClient from "./reducers/awsClient/awsClient";
import announcementSlice from "./reducers/announcement/announcementSlice";

const userPersistConfig = {
  key: "authRoot",
  storage: storage,
};

const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: [
    // "menuSelect",
    "userPopup",
    "accountSettings",
    "breadcrumb",
    "sidenavOpen",
    "mapFilter",
    "mapStomp",
    "htmlContainer",
    "announcement",
  ],
  blacklist: ["notice", "theme", "cookie", "isAuth"],
};

const rootReducer = combineReducers({
  // menuSelect: menuSlice.reducer,
  userPopup: userPopup.reducer,
  notice: persistReducer(userPersistConfig, noticeReducer),
  cookie: cookieReducer,
  accountSettings: accountSlice.reducer,
  // breadcrumb: BreadcrumbSlice.reducer,
  // sidenavOpen: SideNavReducer.reducer,
  theme: persistReducer(userPersistConfig, themeReducer.reducer),
  mapFilter: mapFilterSlice.reducer,
  isAuth: ValidAuthSlice.reducer,
  htmlContainer: htmlContainerReducer.reducer,
  stomp: stompReducer,
  mapStomp: stompMapReducer,
  subscriptionStomp: stompSubscriptionReducer,
  awsClient: awsClient.reducer,
  announcement: announcementSlice.reducer,
});
// const rootReducer = combineReducers({
//   menuSelect: persistReducer(persistConfig, menuSlice.reducer),
//   userPopup: persistReducer(persistConfig,userPopup.reducer),
//   notice: persistReducer(userPersistConfig,noticeReducer),
//   cookie: persistReducer(userPersistConfig,cookieReducer),
//   accountSettings: persistReducer(persistConfig,accountSlice.reducer),
//   breadcrumb: persistReducer(persistConfig,BreadcrumbSlice.reducer),
//   sidenavOpen: persistReducer(persistConfig,SideNavReducer.reducer),
//   recorderList: persistReducer(persistConfig,RecorderList.reducer),
//   theme: persistReducer(userPersistConfig,themeReducer.reducer),
//   mapFilter: persistReducer(persistConfig,mapFilterSlice.reducer),
//   dashboardData: persistReducer(persistConfig,dashboardDataSlice.reducer),
//   dashboardSearchData: persistReducer(persistConfig,dashboardSearchData.reducer)
// });

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware:
    process.env.NODE_ENV === "development"
      ? [
          ...getDefaultMiddleware({
            serializableCheck: false,
          }),
          // logger,
          stompMiddleware,
        ]
      : [
          ...getDefaultMiddleware({
            serializableCheck: false,
          }),
          stompMiddleware,
        ],
  devTools: process.env.NODE_ENV !== "production",
  preloadedState: {
    // counter: {
    //   value: 0,
    //   status: "idle",
    // },
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export const persistor = persistStore(store);
